import Keycloak from "keycloak-js";
import {
  KEYCLOAK_CLIENT_ID,
  KEYCLOAK_AUTH_SERVICE,
  KEYCLOAK_REALM,
} from "./base";

interface KeycloakTokens {
  idToken?: string;
  refreshToken?: string;
  token?: string;
}

export const handleTokensUpdated = (tokens: KeycloakTokens) => {
  if (tokens.token) {
    localStorage.setItem("token", tokens.token);
  }
};

// 🔐 Singleton instance (module-scoped cache)
let keycloakInstance: Keycloak | null = null;

export const getKeycloak = (): Keycloak => {
  if (!keycloakInstance) {
    const keycloakConfig: Keycloak.KeycloakConfig = {
      realm: KEYCLOAK_REALM || "",
      url: KEYCLOAK_AUTH_SERVICE,
      clientId: KEYCLOAK_CLIENT_ID || "",
    };

    keycloakInstance = new Keycloak(keycloakConfig);
  }

  return keycloakInstance;
};
